import { render, staticRenderFns } from "./MfcCheckbox.vue?vue&type=template&id=74e96ad0&scoped=true&"
import script from "./MfcCheckbox.vue?vue&type=script&lang=js&"
export * from "./MfcCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./MfcCheckbox.vue?vue&type=style&index=0&id=74e96ad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e96ad0",
  null
  
)

export default component.exports